import { observer } from 'mobx-react-lite'
import { TryOnPage } from 'page/tryon/TryOnPage'
import { route } from 'store/route'

export const Routing = observer(() => {
  if (route.is('/tryon/*')) return <TryOnPage />
  return null
})
